var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('ag-table',{ref:"agTableRef",attrs:{"columns":_vm.columns,"rows":_vm.answersRows,"row-height":80,"max-height":"calc(100vh - 400px)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }